import { useContext } from 'react';
import { AppProviderContext } from '../providers/AppProvider';

export const useBreadcrumbs = () => {
  const { setBreadcrumbs, breadcrumbs } = useContext(AppProviderContext);
  return { setBreadcrumbs, breadcrumbs };
};
